/** Sidebar + route entry when backend role permissions omit Daily Dose. */
export const DAILY_DOSE_MENU_LABEL = "Micro Learnings";

export const DAILY_DOSE_MENU_ITEM = {
  text: DAILY_DOSE_MENU_LABEL,
  path: "/dailyDose",
  submenu: [],
  icon: "TipsAndUpdatesIcon",
};

export const DAILY_DOSE_ROUTE_PATH = "/dailyDose";

const isDailyDoseMenuPath = (path = "") => String(path).toLowerCase() === "/dailydose";

export const isEmployeeLoginRole = (roleType = "") => {
  const role = String(roleType).trim().toLowerCase();
  if (!role) {
    return false;
  }
  return role === "employee" || role === "prohire employee" || role.endsWith(" employee");
};

/** Employee sidebar: show Micro Learnings instead of legacy Daily Dose label from permissions. */
export const normalizeDailyDoseMenuLabel = (menus = [], roleType = "") => {
  if (!Array.isArray(menus) || !isEmployeeLoginRole(roleType)) {
    return menus;
  }

  return menus.map((item) => {
    if (!isDailyDoseMenuPath(item?.path)) {
      return item;
    }
    return { ...item, text: DAILY_DOSE_MENU_LABEL };
  });
};

export const appendDailyDoseMenuIfMissing = (menus = []) => {
  if (!Array.isArray(menus)) {
    return [DAILY_DOSE_MENU_ITEM];
  }

  const hasDailyDose = menus.some((item) => isDailyDoseMenuPath(item?.path));

  if (hasDailyDose) {
    return menus;
  }

  return [...menus, DAILY_DOSE_MENU_ITEM];
};
